/**
 * 수강생 화면 권한 — **판단은 여기 한 곳** (#59 S8, 사장님 10-11: «권한 기준 = 웹 사이드바에 보이는 권한 하나로 통일»).
 *
 * 보는 곳: 사이드바(SidebarStyle.vue v-if) · 라우터 가드(router/index.js) · 서버 API 관문(server.js canUseScreens)
 *          · 확장(서버 confirmlogin 의 screenAuth 로 받는다 — 확장은 이 파일을 못 읽는다).
 * 화면이 보이는 조건 = 묶음(group) 조건 && 항목 조건. 각 조건 안은 OR. showsales 는 addAccount 도 참(라우터 hasPermission 과 같다).
 * showdeveloper 우회는 여기 없다(사이드바와 같다). 서버 API 는 authPass 처럼 개발자를 통과시킨다 — server.js canUseScreens.
 * 사이드바 밖 화면(주석으로 숨긴 메뉴 — nomad.sourcingmaster·sourcingmasterv2·sourcingVerify·saveitem·Ad.adMarketing)은
 * 이 표에 없다 — 손대지 않았다(라우터 requiresAuth 그대로).
 */
const SCREEN_GROUPS = {
  nomad: ['shownomadv2', 'showNomadMenu', 'showNomadKeyword', 'showNomadCategory', 'showNomadAdKeyword'], // 사이드바 «노마드클럽» 묶음
  ad: ['showAd', 'showNomadAdManage', 'showAdManager'],                                                     // 사이드바 «광고» 묶음
};

const SCREENS = {
  // 노마드클럽 묶음
  'nomad.sourcingmasterTS': { group: 'nomad', any: ['shownomadv2', 'showNomadMenu'] },
  'nomad.sourcingmasterTF': { group: 'nomad', any: ['shownomadv2', 'showNomadMenu'] },
  'nomad.sourcingmasterTF2': { group: 'nomad', any: ['shownomadv3'] },
  'nomad.saveitemM': { group: 'nomad', any: ['shownomadv2', 'showNomadMenu'] },
  'nomad.nomadKeywordAnalysis': { group: 'nomad', any: ['shownomadv2', 'showNomadKeyword'] },
  'nomad.nomadCategoryAnalysis': { group: 'nomad', any: ['shownomadv2', 'showNomadCategory'] },
  'nomad.nomadtraffic': { group: 'nomad', any: ['showTraffic'] },
  'nomad.productTrace': { group: 'nomad', any: ['shownomadv3'] },
  'nomad.userlist': { group: 'nomad', any: ['shownomadv2'] },
  // 판매/분석 묶음(묶음 조건 없음)의 수강생 항목
  'analysis.categorySourcing': { any: ['showKeywordTraffic', 'shownomad'] },
  'analysis.sourcingBoard': { any: ['shownomad'] },
  'nomad.nomadKeywordCollect': { any: ['showKeywordCollect', 'shownomad'] },
  'analysis.keywordDataCollect': { any: ['showKeywordTraffic', 'shownomad'] },
  'analysis.productCompetitiveAnalysis': { any: ['showKeywordTraffic', 'shownomad'] },
  'analysis.exposureTracking': { any: ['showKeywordTraffic', 'shownomad'] },
  // 광고 묶음(항목 조건 없음)
  'Ad.adSourcing': { group: 'ad' },
  // 확장 popup 수강생 창(소싱마스터, Ctrl+Shift+K) — 사이드바에 없는 확장 화면. 기존 확장 v1·v2 기준 그대로
  'ext.popupSourcingMaster': { any: ['shownomad', 'shownomadv2', 'collectNomad'] },
};

function flagOn(user, auth, k) {
  if (k === 'showsales') return !!((user && user.addAccount) || auth.showsales);
  return !!auth[k];
}
function anyOn(user, keys) {
  const auth = (user && user.auth) || {};
  return keys.some((k) => flagOn(user, auth, k));
}

// 사이드바 묶음이 보이나
function canSeeScreenGroup(user, group) {
  const keys = SCREEN_GROUPS[group];
  return !!keys && anyOn(user, keys);
}

// 화면이 보이나 — 표에 없는 화면은 null(이 표가 판단하지 않는다)
function canSeeScreen(user, name) {
  const rule = SCREENS[name];
  if (!rule) return null;
  if (!user || !user.auth) return false;
  if (rule.group && !canSeeScreenGroup(user, rule.group)) return false;
  return rule.any ? anyOn(user, rule.any) : true;
}

// 표 전체 → { 화면: 참/거짓 } (서버가 확장에 내려준다)
function screenAuthOf(user) {
  const out = {};
  Object.keys(SCREENS).forEach((name) => { out[name] = canSeeScreen(user, name); });
  return out;
}

module.exports = { SCREEN_GROUPS, SCREENS, canSeeScreen, canSeeScreenGroup, screenAuthOf };
